import { useRef } from "react";
import useScrollOnDrag from "react-scroll-ondrag";
import { SortArrow } from "../../../assets/icons/SortArrow";
import { SortArrows } from "../../../assets/icons/SortArrows";
import {
  SORT_FOLDER_MODIFIED_AT_ASC,
  SORT_FOLDER_MODIFIED_AT_DESC,
  SORT_FOLDER_LABEL_ASC,
  SORT_FOLDER_LABEL_DESC,
} from "../../../common/constants/sort";
import FolderRow from "./FolderRow";

const FoldersTable = ({
  folders,
  foldersSort,
  changeFoldersSort,
  updateFolder,
  deleteFolder,
  tableScrollDisabled,
}) => {
  const ref = useRef();
  const { events } = useScrollOnDrag(ref, {});

  function handleSort(sortAsc, sortDesc) {
    if (foldersSort === sortAsc) {
      changeFoldersSort(sortDesc);
    } else if (
      foldersSort === sortDesc &&
      foldersSort !== SORT_FOLDER_MODIFIED_AT_DESC
    ) {
      changeFoldersSort(SORT_FOLDER_MODIFIED_AT_DESC);
    } else {
      changeFoldersSort(sortAsc);
    }
  }

  return (
    <div
      ref={ref}
      onMouseDown={tableScrollDisabled ? undefined : events.onMouseDown}
      className="d-block tableFixHead"
      style={{
        userSelect: "none",
      }}
    >
      <table className="table table-hover">
        <thead>
          <tr>
            <th
              className="sortable pl-1"
              onClick={() =>
                handleSort(SORT_FOLDER_LABEL_ASC, SORT_FOLDER_LABEL_DESC)
              }
            >
              <div>
                <span className="column-title">Nom</span>
                <div className="sort-container">
                  {foldersSort === SORT_FOLDER_LABEL_ASC ||
                  foldersSort === SORT_FOLDER_LABEL_DESC ? (
                    <SortArrow
                      size={16}
                      className="active"
                      direction={
                        foldersSort === SORT_FOLDER_LABEL_ASC ? "up" : "down"
                      }
                    />
                  ) : (
                    <SortArrows size={16} className="disabled" />
                  )}
                </div>
              </div>
            </th>
            <th
              className="sortable pl-1"
              onClick={() =>
                handleSort(
                  SORT_FOLDER_MODIFIED_AT_ASC,
                  SORT_FOLDER_MODIFIED_AT_DESC,
                )
              }
            >
              <div>
                <span className="column-title">Modification</span>
                <div className="sort-container">
                  {foldersSort === SORT_FOLDER_MODIFIED_AT_ASC ||
                  foldersSort === SORT_FOLDER_MODIFIED_AT_DESC ? (
                    <SortArrow
                      size={16}
                      className="active"
                      direction={
                        foldersSort === SORT_FOLDER_MODIFIED_AT_ASC
                          ? "up"
                          : "down"
                      }
                    />
                  ) : (
                    <SortArrows size={16} className="disabled" />
                  )}
                </div>
              </div>
            </th>
            <th className="px-1" />
          </tr>
        </thead>
        <tbody>
          <FolderRow key="archive-folder" archive />

          {folders &&
            folders.length > 0 &&
            folders.map((folder) => (
              <FolderRow
                key={folder._id}
                folder={folder}
                updateFolder={updateFolder}
                deleteFolder={deleteFolder}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default FoldersTable;
